/* eslint-disable no-unused-vars */

import { JoyspacePermissionType } from './config/permissions.config';

// 0-所有 1-联系人 2-部门 3-群组
export enum SharesMembersType {
  ALL = 0,
  CONTACT = 1,
  DEPARTMENT = 2,
  GROUP = 3,
}

export enum TabKeyType {
  All = 'All',
  RecentlyContact = 'recentlyContact',
  Contact = 'contact',
  Department = 'department',
  Groups = 'groups',
  WorkLine = 'workLine',
}

// 文件
export enum FolderTypeEnum {
  MY = 8, // '我的文件'
  SHARE = 12, // 共享文件
}

// 设置公开文件夹
export enum OpenFolderStatus {
  'OPEN' = 2,
  'CLOSE' = 1,
}

export enum FileType {
  'Page' = 1,
  'Folder' = 4,
  'File' = 6,
}

export enum PermissionEnum {
  TEAM_CREATE = 'TEAM_CREATE',
  TEAM_VIEW = 'TEAM_VIEW',
  TEAM_EDIT = 'TEAM_EDIT',
  TEAM_REMOVE = 'TEAM_REMOVE',
  TEAM_MEMBER_CREATE = 'TEAM_MEMBER_CREATE',
  TEAM_MEMBER_VIEW = 'TEAM_MEMBER_VIEW',
  TEAM_MEMBER_REMOVE = 'TEAM_MEMBER_REMOVE',
  SPACE_CREATE = 'SPACE_CREATE',
  SPACE_VIEW = 'SPACE_VIEW',
  SPACE_EDIT = 'SPACE_EDIT',
  SPACE_REMOVE = 'SPACE_REMOVE',
  CATEGORY_CREATE = 'CATEGORY_CREATE',
  CATEGORY_VIEW = 'CATEGORY_VIEW',
  CATEGORY_EDIT = 'CATEGORY_EDIT',
  CATEGORY_REMOVE = 'CATEGORY_REMOVE',
  PAGE_CREATE = 'PAGE_CREATE',
  PAGE_READ = 'PAGE_READ',
  PAGE_EDIT = 'PAGE_EDIT',
  PAGE_MOVE = 'PAGE_MOVE',
  PAGE_COPY = 'PAGE_COPY',
  PAGE_VIEW = 'PAGE_VIEW',
  PAGE_PUBLISH = 'PAGE_PUBLISH',
  PAGE_UNPUBLISH = 'PAGE_UNPUBLISH',
  PAGE_PARENT_CHANGE = 'PAGE_PARENT_CHANGE',
  PAGE_REMOVE = 'PAGE_REMOVE',
  NOTE_CREATE = 'NOTE_CREATE',
  NOTE_REMOVE = 'NOTE_REMOVE',
  NOTE_RESOLVE = 'NOTE_RESOLVE',
  COMMENT_CREATE = 'COMMENT_CREATE',
  COMMENT_REMOVE = 'COMMENT_REMOVE',
  SHARE_CREATE = 'SHARE_CREATE',
  SHARE_EDIT = 'SHARE_EDIT',
  SHARE_VIEW = 'SHARE_VIEW',
  SHARE_REMOVE = 'SHARE_REMOVE',
  ACCESS_DENY = 'ACCESS_DENY',
  FOLDER_CREATE = 'FOLDER_CREATE',
  FOLDER_EDIT = 'FOLDER_EDIT',
  FOLDER_REMOVE = 'FOLDER_REMOVE',
  FOLDER_MOVE = 'FOLDER_MOVE',
  FOLDER_COPY = 'FOLDER_COPY',
  FOLDER_VIEW = 'FOLDER_VIEW',
  FOLDER_PARENT_CHANGE = 'FOLDER_PARENT_CHANGE',
  MODAL_NOT_FOUND = 'MODAL_NOT_FOUND',
  REPORT_EDIT = 'REPORT_EDIT',
  REPORT_PUB = 'REPORT_PUB',
  FOLDER_PUBLIC_SET = 'FOLDER_PUBLIC_SET',
  SHARE_MANAGE = 'SHARE_MANAGE',
}

// 1:仅展示所有者，2:可编辑/所有者，3：仅阅读/可编辑/所有者
export enum SelectVal {
  ALL = 3,
  EDIT_OWNER = 2,
  OWNER = 1,
}

export enum SecuresTypeVal {
  Share = 1,
  Download = 2,
}
// 1.文件夹所有者，2.文件夹仅阅读者，3. 文件夹可编辑者, 5.文件所有者， 6.文件仅阅读者，7.文件可编辑者
export enum SelectRoleVal {
  FolderAll = 2,
  FolderOnlyEdit = 1,
  FolderOnlyOwner = 0,
  FileAll = 2,
  FileOnlyEdit = 1,
  FileOnlyOwner = 0,
}
export enum ShareType {
  ShareAI = 0,
  ShareMessage = 1,
}
export interface SelectType {
  id: string;
  avatar: string;
  name: string;
  desc: string;
  type: string;
  checked?: boolean;
  permissionType: JoyspacePermissionType;
}

export interface HeadersType {
  appId?: string;
  appKey?: string;
  appVersion: string;
  appClient?: string;
  appStage: string;
  appGwVersion?: number;
  appSecrerKey: string;
  appDeviceid?: string;
  requestUrl?: string;
  ssoLoginUrl?: string;
  handleToken?: boolean;
}

export enum SearchType {
  All = '0',
  Contacts = '1',
  Group = '2',
  App = '3',
  JoySpace = '4',
  Task = '5',
  Schedule = '6',
  MessageHistory = '-1',
  Department = '7',
  Device = '8',
}

export const tabKeyBySearchType = {
  [TabKeyType.All]: SearchType.All,
  [TabKeyType.Contact]: SearchType.Contacts,
  [TabKeyType.Department]: SearchType.Department,
  [TabKeyType.Groups]: SearchType.Group,
};
// “1”：外部；  “2”：未认证； “3”：正式；  “4”：跨租户； “5”：跨平台；
export enum UserType {
  External = '1',
  NoAuth = '2',
  Regular = '3',
  CrossTenant = '4',
  CrossPlatform = '5',
}

// 根文件权限
export enum joyspacePermissionType {
  ReadAll = 0, // 0 拥有者
  ReadOnly = 2, // 只读
  ReadWrite = 1, // 读写
  ReadDel = -99, // 删除权限
  ReadNothing = -1, // 文档被删除或者无权限
}
